import { Component } from '@angular/core';
import { PlausibleService } from './plausible.service';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(public plausible: PlausibleService) {}
}
